



















import Translation from '@/mixins/Translation'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import ListItem from '@/components/list/ListItem.vue'
import MenuImg from '@/components/image/MenuImg.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'

@Component({
  components: {BttPopup, ListItem, MenuImg},
})
export default class SelectInvoiceActionPopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean

  open: boolean = true

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  @Watch('open', {immediate: true})
  __open(value) {
    this.$emit('input', value)
  }

  close() {
    this.open = false
  }

  onClickCancel() {
    this.close()
  }

  get actionList() {
    const {ts} = this
    return [
      {
        name: ts('to-issue'),
        routeName: 'issue',
        image: 'issue',
      },
      {
        name: ts('to-lookup-transfer'),
        routeName: 'received-invoices',
        image: 'invoice',
      }
    ]
  }

  actionSelected(routeName) {
    this.$emit('select-action', routeName)
    this.close()
  }
}
